import ConeCrusherBW from './images/ConeCrusherBW.png';
import GyratoryCrusherBW from './images/GyratoryCrusherBW.png';
import jawCrusherBW from './images/JawCrusherBW.png';
import VSIBW from './images/VSIBW.png';
import HSIBW from './images/HSIBW.png';
import hybridBW from './images/HybridBW.png';
import SAGMillBW from './images/SAGMillBW.png';
import BallMillBW from './images/BallMillBW.png';
import RodMillBW from './images/RodMillBW.png';
import HPGRBW from './images/HPGRBW.png';
import ConeCrusherBW2 from './images/ConeCrusherBW_2.png';
import GyratoryCrusherBW2 from './images/GyratoryCrusherBW_2.png';
import jawCrusherBW2 from './images/JawCrusherBW_2.png';
import VSIBW2 from './images/VSIBW_2.png';
import HSIBW2 from './images/HSIBW_2.png';
import hybridBW2 from './images/HybridBW_2.png';
import SAGMillBW2 from './images/SAGMillBW_2.png';
import BallMillBW2 from './images/BallMillBW_2.png';
import RodMillBW2 from './images/RodMillBW_2.png';
import HPGRBW2 from './images/HPGRBW_2.png';
import GenericCrusherHighBinBW from './images/GenericCrusherHighBinBW.png';
import type { UnitInfoGenericCrusherInterface } from 'store/units/types';
import { GenericCrusherTypes } from './GenericCrusherTypes';

const images = new Map<string, string>();
const images2 = new Map<string, string>();

images.set(`${GenericCrusherTypes.CONE_CRUSHER}`, ConeCrusherBW);
images.set(`${GenericCrusherTypes.GYRATORY_CRUSHER}`, GyratoryCrusherBW);
images.set(`${GenericCrusherTypes.JAW_CRUSHER}`, jawCrusherBW);
images.set(`${GenericCrusherTypes.VSI}`, VSIBW);
images.set(`${GenericCrusherTypes.SAG_MILL}`, SAGMillBW);
images.set(`${GenericCrusherTypes.AG_MILL}`, SAGMillBW);
images.set(`${GenericCrusherTypes.BALL_MILL}`, BallMillBW);
images.set(`${GenericCrusherTypes.ROD_MILL}`, RodMillBW);
images.set(`${GenericCrusherTypes.HPGR}`, HPGRBW);
images.set(`${GenericCrusherTypes.HSI}`, HSIBW);
images.set(`${GenericCrusherTypes.HYBRID}`, hybridBW);

images2.set(`${GenericCrusherTypes.CONE_CRUSHER}`, ConeCrusherBW2);
images2.set(`${GenericCrusherTypes.GYRATORY_CRUSHER}`, GyratoryCrusherBW2);
images2.set(`${GenericCrusherTypes.JAW_CRUSHER}`, jawCrusherBW2);
images2.set(`${GenericCrusherTypes.VSI}`, VSIBW2);
images2.set(`${GenericCrusherTypes.SAG_MILL}`, SAGMillBW2);
images2.set(`${GenericCrusherTypes.AG_MILL}`, SAGMillBW2);
images2.set(`${GenericCrusherTypes.BALL_MILL}`, BallMillBW2);
images2.set(`${GenericCrusherTypes.ROD_MILL}`, RodMillBW2);
images2.set(`${GenericCrusherTypes.HPGR}`, HPGRBW2);
images2.set(`${GenericCrusherTypes.HSI}`, HSIBW2);
images2.set(`${GenericCrusherTypes.HYBRID}`, hybridBW2);

export const getImageGenericCrusher = ({
  modelName,
  useHighBin = false,
}: Pick<UnitInfoGenericCrusherInterface, 'modelName'> & {
  useHighBin?: boolean;
}): string => {
  if (modelName === undefined) {
    return '';
  }

  if (useHighBin) {
    return GenericCrusherHighBinBW;
  }

  return images.get(`${modelName}`) ?? '';
};

export const getImageGenericCrusher2 = ({
  modelName,
  useHighBin = false,
}: Pick<UnitInfoGenericCrusherInterface, 'modelName'> & {
  useHighBin?: boolean;
}): string => {
  if (modelName === undefined) {
    return '';
  }

  if (useHighBin) {
    return GenericCrusherHighBinBW;
  }

  return images2.get(`${modelName}`) ?? '';
};
